import { z } from "zod";

import { UserInterfaceDtoSchema } from "../../../../dtos/user-interfaces";

export const PluginUserInterfaceSchema_2024_05_05 = UserInterfaceDtoSchema;

export type PluginUserInterfaceType_2024_05_05 = z.infer<
  typeof PluginUserInterfaceSchema_2024_05_05
>;
